import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicOrderAndDegree = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="ORDER AND DEGREE"
      videos={[
        "https://www.youtube.com/embed/bjJZKTrCBNw",
      ]}
      takeaways={[]} // Empty takeaways as requested
      questions={[]} // Empty questions as requested
      exampleVideos={[]} // Empty example videos
    />
);
}

export default ModuleSubtopicOrderAndDegree;